import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

import type {EquipmentFlagCategory} from '../types/EquipmentFlagCategory';

type FlagColors = {
  backgroundColor: ThemeColorPath;
  color: ThemeColorPath;
};

export function getFlagColorsForCategory(category: EquipmentFlagCategory) {
  return match<EquipmentFlagCategory, FlagColors>(category)
    .with('availableHighlightFeature', () => ({
      backgroundColor: 'palettes.blue.30.100',
      color: 'palettes.blue.80.100',
    }))
    .with('availableFeature', () => ({
      backgroundColor: 'palettes.blue.10.100',
      color: 'palettes.blue.80.100',
    }))
    .with('missingHighlightFeature', () => ({
      backgroundColor: 'palettes.red.30.100',
      color: 'palettes.red.90.100',
    }))
    .with('missingFeature', () => ({
      backgroundColor: 'palettes.red.10.100',
      color: 'palettes.red.80.100',
    }))
    .exhaustive();
}
